import { useEffect, useState } from 'react'
import { userInterface } from "../../interfaces/userInterface"
import { AuthContext } from "./AuthContext"
import { authApi } from '../../services/api/api'
import { useLocation } from 'react-router-dom'


export const AuthProvider = ({ children }: { children: JSX.Element }) => {

    const [user, setUser] = useState<userInterface | null>(null)
    const [loading, setLoading] = useState(true) // <--- ADICIONE ESTA LINHA

    const [theme, setTheme] = useState('white')

    const [token, setToken] = useState('')

    const [lastRoute, setLastRoute] = useState('')

    const api = authApi()

    const location = useLocation()
    // delay para teste de carregamento
    // const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    useEffect(() => {
        const themeStorage = localStorage.getItem('biblioteca-acreditar-theme')

        setLastRoute(location.pathname)
        console.log(lastRoute)
        if (themeStorage) {
            setTheme(themeStorage)
        }
    }, [])

    useEffect(() => {
        const checkLogin = async () => {
            // await delay(3000);
            const storageData = localStorage.getItem('biblioteca-acreditar-token')

            if (storageData) {
                setToken(storageData)
                const data = await api.logged(storageData)
                if (data) {
                    setUser(data)
                }
            }

            setLoading(false)
        }
        checkLogin()
    }, [])

    const toggleTheme = (theme: string) => {
        localStorage.setItem('biblioteca-acreditar-theme', theme)
        setTheme(theme)
    }

    const logged = async () => {
        const storageData = localStorage.getItem('biblioteca-acreditar-token')

        if (storageData) {
            const data = await api.logged(storageData)
            if (data) {
                setUser(data)
                return true
            }
            return false
        }
        return false
    }

    const signin = async (email: string, password: string) => {

        const data = await api.signin(email, password)

        if (data.response?.status > 400) {
            return false
        }

        if (data && data.token) {
            setUser(data)
            localStorage.setItem('biblioteca-acreditar-token', data.token)


            return true
        }

        return false
    }

    const signout = async () => {
        localStorage.removeItem('biblioteca-acreditar-token');

        setUser(null);
        setToken(''); 
    };

    const storeBook = async (form: object) => {

        const response = await api.storeBook(form)

        return response?.data
    }

    if (loading) {
        return (
            <div className='bg-blue3' style={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 9999
            }}>
                {/* Logo com efeito de pulsação */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    animation: 'fadeInOut 2s ease-in-out infinite'
                }}>
                    <img
                        src="../../assets/images/logoMiniBranco.png"
                        alt="Logo"
                        style={{ width: '80px', marginBottom: '20px' }}
                    />

                    <h1 style={{
                        fontFamily: 'Gruppo, sans-serif',
                        color: 'white',
                        fontSize: '28px',
                        letterSpacing: '4px',
                        fontWeight: 300
                    }}>
                        BIBLIOTECA
                    </h1>

                    {/* Linha de carregamento elegante */}
                    <div style={{
                        width: '150px',
                        height: '2px',
                        background: '#002462',
                        marginTop: '20px',
                        position: 'relative',
                        overflow: 'hidden',
                        borderRadius: '10px'
                    }}>
                        <div style={{
                            width: '60px',
                            height: '100%',
                            background: '#3498db',
                            position: 'absolute',
                            animation: 'loadingBar 1.5s infinite ease-in-out'
                        }}></div>
                    </div>
                </div>

                <style>{`
                @keyframes fadeInOut {
                    0%, 100% { opacity: 0.6; transform: scale(0.98); }
                    50% { opacity: 1; transform: scale(1); }
                }
                @keyframes loadingBar {
                    0% { left: -60px; }
                    100% { left: 150px; }
                }
            `}</style>
            </div>
        );
    }

    // Só chega aqui quando o loading for FALSE
    return (
        <AuthContext.Provider value={{ user, loading, setUser, signin, signout, logged, theme, toggleTheme, storeBook, lastRoute, setLastRoute }}>
            {children}
        </AuthContext.Provider>
    );


}